/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  PaymentMethodDto,
  SetupIntentDto,
  UpdatePaymentMethodRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMePaymentMethodsV1Response200 = {
  data: PaymentMethodDto[]
  status: 200
}

export type getMePaymentMethodsV1Response401 = {
  data: void
  status: 401
}

export type getMePaymentMethodsV1ResponseSuccess = (getMePaymentMethodsV1Response200) & {
  headers: Headers;
};
export type getMePaymentMethodsV1ResponseError = (getMePaymentMethodsV1Response401) & {
  headers: Headers;
};

export type getMePaymentMethodsV1Response = (getMePaymentMethodsV1ResponseSuccess | getMePaymentMethodsV1ResponseError)

export const getGetMePaymentMethodsV1Url = () => {




  return `/api/v1/me/payment-methods`
}

/**
 * Returns the authenticated user's saved cards, read live from Stripe. Preferred card appears first. Returns an empty list when the user has no cards yet.
 * @summary List saved payment methods
 */
export const getMePaymentMethodsV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMePaymentMethodsV1Response> => {

  return customFetch<getMePaymentMethodsV1Response>(getGetMePaymentMethodsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type deleteMePaymentMethodV1Response204 = {
  data: void
  status: 204
}

export type deleteMePaymentMethodV1Response401 = {
  data: void
  status: 401
}

export type deleteMePaymentMethodV1Response404 = {
  data: void
  status: 404
}

export type deleteMePaymentMethodV1ResponseSuccess = (deleteMePaymentMethodV1Response204) & {
  headers: Headers;
};
export type deleteMePaymentMethodV1ResponseError = (deleteMePaymentMethodV1Response401 | deleteMePaymentMethodV1Response404) & {
  headers: Headers;
};

export type deleteMePaymentMethodV1Response = (deleteMePaymentMethodV1ResponseSuccess | deleteMePaymentMethodV1ResponseError)

export const getDeleteMePaymentMethodV1Url = (paymentMethodId: string,) => {




  return `/api/v1/me/payment-methods/${paymentMethodId}`
}

/**
 * Detaches the card from the user's Stripe customer. Fails with 404 when the card does not belong to the authenticated user.
 * @summary Delete a saved payment method
 */
export const deleteMePaymentMethodV1 = async (paymentMethodId: string, options?: Parameters<typeof customFetch>[1]): Promise<deleteMePaymentMethodV1Response> => {

  return customFetch<deleteMePaymentMethodV1Response>(getDeleteMePaymentMethodV1Url(paymentMethodId),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type updateMePaymentMethodV1Response204 = {
  data: void
  status: 204
}

export type updateMePaymentMethodV1Response400 = {
  data: void
  status: 400
}

export type updateMePaymentMethodV1Response401 = {
  data: void
  status: 401
}

export type updateMePaymentMethodV1Response404 = {
  data: void
  status: 404
}

export type updateMePaymentMethodV1ResponseSuccess = (updateMePaymentMethodV1Response204) & {
  headers: Headers;
};
export type updateMePaymentMethodV1ResponseError = (updateMePaymentMethodV1Response400 | updateMePaymentMethodV1Response401 | updateMePaymentMethodV1Response404) & {
  headers: Headers;
};

export type updateMePaymentMethodV1Response = (updateMePaymentMethodV1ResponseSuccess | updateMePaymentMethodV1ResponseError)

export const getUpdateMePaymentMethodV1Url = (paymentMethodId: string,) => {




  return `/api/v1/me/payment-methods/${paymentMethodId}`
}

/**
 * Partially updates a saved card: expiry month/year and/or cardholder name — null fields are left untouched. The card number and CVC can never be updated (Stripe does not allow it); changing the number means adding a new card. Fails with 400 when the request is empty or the expiry is invalid, and with 404 when the card does not belong to the authenticated user.
 * @summary Update a saved payment method
 */
export const updateMePaymentMethodV1 = async (paymentMethodId: string,
    updatePaymentMethodRequest: UpdatePaymentMethodRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateMePaymentMethodV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateMePaymentMethodV1Response>(getUpdateMePaymentMethodV1Url(paymentMethodId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePaymentMethodRequest)
  }
);}


export type setMePaymentMethodPreferredV1Response204 = {
  data: void
  status: 204
}

export type setMePaymentMethodPreferredV1Response401 = {
  data: void
  status: 401
}

export type setMePaymentMethodPreferredV1Response404 = {
  data: void
  status: 404
}

export type setMePaymentMethodPreferredV1ResponseSuccess = (setMePaymentMethodPreferredV1Response204) & {
  headers: Headers;
};
export type setMePaymentMethodPreferredV1ResponseError = (setMePaymentMethodPreferredV1Response401 | setMePaymentMethodPreferredV1Response404) & {
  headers: Headers;
};

export type setMePaymentMethodPreferredV1Response = (setMePaymentMethodPreferredV1ResponseSuccess | setMePaymentMethodPreferredV1ResponseError)

export const getSetMePaymentMethodPreferredV1Url = (paymentMethodId: string,) => {




  return `/api/v1/me/payment-methods/${paymentMethodId}/preferred`
}

/**
 * Marks the card as the user's default (preferred) payment method in Stripe. Only one card can be preferred at a time. Fails with 404 when the card does not belong to the authenticated user.
 * @summary Set payment method as preferred
 */
export const setMePaymentMethodPreferredV1 = async (paymentMethodId: string, options?: Parameters<typeof customFetch>[1]): Promise<setMePaymentMethodPreferredV1Response> => {

  return customFetch<setMePaymentMethodPreferredV1Response>(getSetMePaymentMethodPreferredV1Url(paymentMethodId),
  {
    ...options,
    method: 'PUT'


  }
);}


export type createMePaymentMethodSetupIntentV1Response200 = {
  data: SetupIntentDto
  status: 200
}

export type createMePaymentMethodSetupIntentV1Response401 = {
  data: void
  status: 401
}

export type createMePaymentMethodSetupIntentV1ResponseSuccess = (createMePaymentMethodSetupIntentV1Response200) & {
  headers: Headers;
};
export type createMePaymentMethodSetupIntentV1ResponseError = (createMePaymentMethodSetupIntentV1Response401) & {
  headers: Headers;
};

export type createMePaymentMethodSetupIntentV1Response = (createMePaymentMethodSetupIntentV1ResponseSuccess | createMePaymentMethodSetupIntentV1ResponseError)

export const getCreateMePaymentMethodSetupIntentV1Url = () => {




  return `/api/v1/me/payment-methods/setup-intent`
}

/**
 * Creates a Stripe SetupIntent (creating the Stripe customer on first use) and returns its client secret. The frontend passes the client secret to Stripe Elements, which sends the card data directly to Stripe — card details never touch this API (PCI SAQ-A).
 * @summary Create a SetupIntent for adding a card
 */
export const createMePaymentMethodSetupIntentV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<createMePaymentMethodSetupIntentV1Response> => {

  return customFetch<createMePaymentMethodSetupIntentV1Response>(getCreateMePaymentMethodSetupIntentV1Url(),
  {
    ...options,
    method: 'POST'


  }
);}


